import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import Tabs  from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import TabContent from 'react-bootstrap/TabContent';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import { API } from 'aws-amplify';
import Moment from 'react-moment';

const params = {
    headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
}

const DeviceSubsRenewal = (props) => {
    const [assets, setAssets] = useState([]);
    const [assetList, setAssetList] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [asset,setAsset] = useState('');
    const [locationList, setLocationList] = useState([]);
    const [countryList, setCountryList] = useState([]);
	const [location, setLocation] = useState('');
	const [country, setCountry] = useState('');
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dec']
    const statuslist =[
        {id: 'active',desc:'Active'},
        {id: 'inactive',desc:'Inactive'},
        {id: 'removed',desc:'Removed'}]

    let formatDate = ['DD-MM-YYYY','dd/MM/yyyy']
    if (props.formatDate!==formatDate[0]){
        formatDate = ['MM-DD-YYYY','MM/dd/yyyy']
    }

    // Load asset
    /* eslint-disable no-alert, no-console */
    useEffect(()=>{
        const fetchAssets = async () => {
            setIsLoading(true);

            const data = await API.get('asset','/', params)
            data.sort((a, b) => (new Date(a.inst_date).getMonth() > new Date(b.inst_date).getMonth()) ? 1 : -1)

            //Get user asset list
            // let user_assets = []
            // user_assets = await API.get('user_assets','/' + props.user.username, params)
            let user_assets = props.user.user_assets || []

            let assetsFiltered = []
            if (user_assets){
                // user_assets = user_assets.assets;
                assetsFiltered = data.filter(x => user_assets.find(i => i === x.id));
            }

            assetsFiltered = assetsFiltered.map(item => {
                let stat = "text-dark";
                if (new Date(item.expiry_date) <= new Date() ) 
                    stat = "text-danger"

                return {...item, 
                 statusCss: stat,
                }})

            if (assetsFiltered.length>0){
                setAssets(assetsFiltered);
                setAssetList(assetsFiltered);
            }

            setIsLoading(false);
        }
        
        if (props.user && props.user.user_assets)
            fetchAssets();

    }, [props.user]);

    // Load location
	// useEffect(()=>{
	// 	const fetchLocation = async () => {
    //         const loc = [...new Set(assets.map(item => item.location))];
	// 		setLocationList(loc);
	// 	}
    //     fetchLocation();
    // }, [assets]);

    // Load country
	useEffect(()=>{
		const fetchCountry = async () => {
            let loc = [...new Set(assets.map(item => item.country))];
            loc = loc.filter(item => item !== undefined);
            loc.sort((a, b) => (a > b) ? 1 : -1)

            // // remove blanks
            // loc = Object.entries(loc).reduce((a,[k,v]) => (v === null || v === '' ? a : {...a, [k]:v}), {})

            if (loc.length === 1)
                setCountry(loc[0]);

			setCountryList(loc);
		}
        fetchCountry();

    }, [assets]);

    // Load location
	useEffect(()=>{
		const fetchLocation = async () => {
            let loc=[]
            if (country){
                loc = [...new Set(assets.filter(item => item.country === country).map(item => item.location))];
            }else{
                loc = [...new Set(assets.map(item => item.location))];
            }
            loc = loc.filter(item => item !== undefined);
            loc.sort((a, b) => (a > b) ? 1 : -1)
			setLocationList(loc);
		}
        fetchLocation();
    }, [assets, country]);

    useEffect(() => {
        const handleSearch = () => {
            let results = assets;
            // Site Reference
            if (asset){
                results = results.filter(results =>
                    (results.name && results.name.toLowerCase().includes(asset.toLowerCase())) ||
                    (results.address && results.address.toLowerCase().includes(asset.toLowerCase())))
            }
            // country
            if (country){
                results = results.filter(results =>
                    results.country && results.country.toLowerCase().includes(country.toLowerCase())
            )}
            // Location
            if (location){
                results = results.filter(results =>
                    results.location && results.location.toLowerCase().includes(location.toLowerCase())
            )}
            setAssetList(results);
        }
		handleSearch();
    }, [location, country, asset, assets]);

    function findStatus(id){
        const item = statuslist.find(x => x.id === id)
        return ((item && item.desc) || '')
    }

    return (

        <div className="DeviceList">
            <div className="col-md-12">
                <div className="row header pb-0">
                    <div className="col-4">Annual Subscriptions</div>
                    <div className="col-8 d-flex justify-content-end">
                        <div className="p-2"><h3>Assets</h3></div>
                        <div className="col-md-8">
                            <div className="row">
                            <Form.Group controlId="site_ref" className="col-md-4 ps-4">
                            <Form.Control
                                as="input"
                                value={asset}
                                onChange={e => {setAsset(e.target.value)}}
                                type="text" />
                            </Form.Group>
                            <Form.Group controlId="country" className="col-md-4">
                            <Form.Control
                                as="select"
                                value={country}
                                onChange={e => {setCountry(e.target.value)}}>
                                    <option value="">Country</option>
                                    {countryList.map((item, i) =>
                                        <option key={`country`+i} value={item}>{item}</option>
                                        )}

                            </Form.Control>
                            </Form.Group>
                            <Form.Group controlId="location" className="col-md-4">
                                <Form.Control
                                    as="select"
                                    value={location}
                                    onChange={e => {setLocation(e.target.value)}}>
                                        <option value="">Location</option>
                                        {locationList.map((item, i) =>
                                            <option key={`loc`+i} value={item}>{item}</option>
                                            )}

                                </Form.Control>
                            </Form.Group>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
			        <div className="col-md-12 div-content">
                        {(!isLoading) ? (
                        (assetList.length === 0) ? (
                            // <div className="col-md-12 p-4 text-center text-secondary">No records found</div>
                            ''
                        ):(
                        <div>
                        <Tabs defaultActiveKey={months[new Date().getMonth()]} transition={false} id="mnth">
                            {months.map((mnth,i) =>
                            <Tab key={mnth} eventKey={mnth} title={mnth}>
                                <TabContent className="p-3">
                                <Table responsive bordered hover size="sm" variant="light">
                                    <thead>
                                        <tr key="tbl-tr">
                                        <th className="border-bottom">Asset</th>
                                        <th className="text-center border-bottom">Installation Date</th>
                                        <th className="text-center border-bottom">Expiry Date</th>
                                        <th className="text-center border-bottom">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                    assetList.filter(item => new Date(item.inst_date).getMonth()=== i).map((item, j) => (
                                    <tr key={"tr" + item.id} className="table-tr">
                                        <td className="link border-bottom" onClick={() => props.history.push('/device_det/'+ item.id )}>
                                            {item.name}
                                        </td>
                                        <td className="text-center border-bottom">
                                        <Moment local format={formatDate[0]} date={ item.inst_date } />
                                        </td>
                                        <td className={"text-center border-bottom " + item.statusCss}>
                                            <Moment local format={formatDate[0]} date={ item.expiry_date } />
                                        </td>
                                        <td className="col-md-1 text-center border-bottom">
                                            { findStatus(item.status) }
                                        </td>
                                    </tr>
                                    ))}
                                    </tbody>
                                    </Table>
                                </TabContent>
                            </Tab>
                            )}
                        </Tabs>
                    </div>
                    )):(
                        <div className="col-md-12">
                        <Spinner animation="grow" size="sm" role="status" variant="warning" />
                        <span className="text-dark">  Loading...</span>
                        </div>
                    )}
                    </div>
		        </div>
            </div>

        </div>
    )
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        formatDate: state.auth.formatDate,
    };
  };

export default connect(mapStateToProps)(DeviceSubsRenewal);
